import { FC, PropsWithChildren } from 'react';

import { Box, Text } from '@bonusly/design-system';

import { populateEmojis } from '../../utils/emoji';
import { useBonusTextTokens } from '../recognition/bonus';

export const TextPreview: FC<PropsWithChildren<{ text: string }>> = ({ children, text }) => {
	const tokens = useBonusTextTokens(text);

	return (
		<Text as="div" fontWeight="normal" size="lg" whiteSpace="pre-line">
			{children}
			{tokens.map((token, i) => {
				switch (token.kind as any) {
					case 'AMOUNT':
						return <Amount key={i}>{token.text}</Amount>;

					case 'HASHTAG':
						return <Hashtag key={i}>{token.text}</Hashtag>;

					case 'MENTION':
						return <Recipient key={i}>{token.text}</Recipient>;

					default:
						return (
							<Text as="span" key={i}>
								{populateEmojis(token.text)}
							</Text>
						);
				}
			})}
		</Text>
	);
};

type SegmentProps = {
	children: string;
};

export const Amount: FC<SegmentProps> = ({ children }) => (
	<Box as="span" display="inline-flex" bgColor="points.bgAlpha" h={7} borderRadius="full" alignItems="center" px={2}>
		<Text as="span" color="points.fg">
			{children}
		</Text>
	</Box>
);

export const Hashtag: FC<SegmentProps> = ({ children }) => (
	<Text as="span" display="inline-block" color="purple.600">
		{children}
	</Text>
);

export const Recipient: FC<SegmentProps> = ({ children }) => (
	<Text as="span" display="inline-block" color="primary.fg">
		{children}
	</Text>
);
